import { render, staticRenderFns } from "./TargetingTimeSpentOnSite.vue?vue&type=template&id=1892fdad&"
import script from "./TargetingTimeSpentOnSite.vue?vue&type=script&lang=js&"
export * from "./TargetingTimeSpentOnSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports